import { MultiSelectElement, TextFieldElement } from "react-hook-form-mui";
import { useTranslation } from "react-i18next";

import { GqlSettingsFormTemplateQuestionTag } from "~/__generated__";

export default function QuestionFieldSettings() {
    const { t } = useTranslation("formTemplateEditor");

    const tagOptions = Object.values(GqlSettingsFormTemplateQuestionTag).map(value => ({
        id: value,
        label: t(`formTemplateQuestionForm.${value}TagLabel`),
    }));

    return (
        <>
            <TextFieldElement
                name="description"
                label={t("formTemplateQuestionForm.labelDescription")}
                multiline
                rows={2}
            />
            <TextFieldElement name="placeholder" label={t("formTemplateQuestionForm.labelPlaceholder")} />
            <MultiSelectElement
                name="tags"
                label={t("formTemplateQuestionForm.labelTags")}
                options={tagOptions}
                variant="filled"
                showChips={true}
            />
        </>
    );
}
